import { Box, Chip, Grid, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { Labeled, NumberField, ReferenceField, TextField, FunctionField, useNotify } from "react-admin";
import { getFile } from "server/components/DownloadFile";
import { administrationRequests } from "api/administrationApi";

const InfoSection = () => {
  const notify = useNotify();

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
      >
        <Labeled label="Име">
          <TextField source="name" emptyText="-" />
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <Labeled label="Квалификационна степен">
          <ReferenceField
            source="degreeId"
            reference={administrationRequests.getDegreesSelect()}
            emptyText="-"
          >
            <TextField source="name" emptyText="-" />
          </ReferenceField>
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <Labeled label="Специалност">
          <ReferenceField
            source="specialityId"
            reference={administrationRequests.getSpecialitiesSelect()}
            emptyText="-"
          >
            <TextField source="name" emptyText="-" />
          </ReferenceField>
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <Labeled label="Вид обучение">
          <ReferenceField
            source="studyTypeId"
            reference={administrationRequests.getStudyTypesSelect()}
            emptyText="-"
          >
            <TextField source="name" emptyText="-" />
          </ReferenceField>
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <Labeled label="Прием след">
          <ReferenceField
            source="admissionAfterEducationLevelId"
            reference={administrationRequests.getAdmissionAfterEducationLevelsSelect()}
            link={false}
            emptyText="-"
          >
            <TextField source="name" emptyText="-" />
          </ReferenceField>
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <Labeled label="Влиза в сила от">
          <TextField source="validFrom" emptyText="-" />
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <Labeled label="Срок на обучение">
          <NumberField
            source="yearsOfStudy"
            textAlign="left"
            emptyText="-"
          />
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <Labeled label="Засегнати години">
          <FunctionField
            render={curriculum =>
              curriculum.specialitiesAffectedYears?.length ? (
                <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                  {curriculum.specialitiesAffectedYears
                    .map(item => item.yearOfStudy)
                    .sort((a, b) => a - b)
                    .map(year => (
                      <Chip
                        key={year}
                        label={year}
                        size="small"
                      />
                    ))}
                </Box>
              ) : (
                "-"
              )
            }
          />
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <Labeled label="Учебен план (pdf)">
          <FunctionField
            render={curriculum =>
              curriculum.pdfDocumentId ? (
                <Box
                  sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                  onClick={() => getFile(curriculum.pdfDocumentId, notify)}
                >
                  <DownloadIcon color="primary" />
                  <Typography
                    color="primary"
                    sx={{ textDecoration: "underline", fontSize: "14px", paddingLeft: "8px" }}
                  >
                    {`Учебен план-${curriculum.validFrom}-${curriculum.name}.pdf`}
                  </Typography>
                </Box>
              ) : (
                "-"
              )
            }
          />
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default InfoSection;
